module.exports = __webpack_public_path__ + "assets/media/new_order.7a3974be.mp3";